import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { WhatsAppFloat, CookieBanner } from "./Floating";

export default function StoreLayout() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return (
    <div className="min-h-screen bg-na-bg">
      <a href="#conteudo" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-white focus:p-3">Pular para o conteúdo</a>
      <Header />
      <main id="conteudo"><Outlet /></main>
      <Footer />
      <CartDrawer />
      <WhatsAppFloat offset={pathname.startsWith("/produto/")} />
      <CookieBanner />
    </div>
  );
}
